const States = {
    INITIAL: 'INITIAL',
    ERROR: 'ERROR',
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
};

export default States;